
import PortfolioTest from '@/models/test/PortfolioTest'
import PortfolioTestAnswer from '@/models/test/PortfolioTestAnswer'

export default function portfolio (Vue) {
  Vue.prototype.$PortfolioTest = PortfolioTest
  Vue.prototype.$PortfolioTestAnswer = PortfolioTestAnswer

  Vue.prototype.$getPortfolioTests = async function (training) {
    let tests = await PortfolioTest.list({ training })
    tests = tests.reduce((acc, cur) => {
      if (!acc[cur.code]) acc[cur.code] = {}
      acc[cur.code] = cur
      return acc
    }, {})
    return tests
  }
}
